<div class="ui-tabs">
  <div class="ui-tabs-panel js-tab-container-grade">
    <table>
      <thead>
        <tr>
          <th>{{'data.clientContract.table.ref' | cxTranslate}}</th>
          <th>{{'data.clientContract.table.description' | cxTranslate}}</th>
          <th>{{'data.clientContract.table.price' | cxTranslate}}</th>
          <th>{{'data.clientContract.table.agreed' | cxTranslate}}</th>
          <th>{{'data.clientContract.table.available' | cxTranslate}}</th>
          <th>{{'data.clientContract.table.lastOrder' | cxTranslate}}</th>
          <th>{{'data.clientContract.table.validity' | cxTranslate}}</th>
        </tr>
      </thead>
      <tbody *ngIf="contract$ | async as contract">
        <tr *ngFor="let product of contract.productList">
          <td >{{getContractReference(product.contractReference.entry, 'CC_'+contract.contractId)}} </td>
          <td>{{product.name}}</td>
          <td>&euro;{{formatNumber(product.price?.value)}}{{siteUid === 'gonvarriPortugal' ? '/Ton' : '/Tm'}}</td>
          <td>
            {{formatNumber(getStockLevel(contract.stockLevelMap, product.code))}}
          </td>
          <td
            [className]="getStockLevel(contract.stockLevelMap, product.code) > 0 ? 'stock' : 'no-stock'"
            (click)="selectProduct($event, product)"
          >
            <div
              *ngIf="getStockLevel(contract.stockLevelMap, product.code) > 0"
            >
              {{formatNumber(getStockLevel(contract.stockLevelMap, product.code))}}
            </div>
          </td>
          <td>
            {{getLastOrder(contract.lastOrderDateMap, product.code) ? formatDate(getLastOrder(contract.lastOrderDateMap, product.code)) : ""}}
          </td>
          <td>
            {{formatDate(contract.expiryDateContract)}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
